import axios from "axios";
import React, { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

function getIssuuEmbedUrl(normalUrl) {
  try {
    const url = new URL(normalUrl);
    const paths = url.pathname.split("/");
    const user = paths[1];
    const doc = paths[3];
    return `https://e.issuu.com/embed.html?d=${doc}&u=${user}`;
  } catch (e) {
    return "";
  }
}

export const Catalogo = () => {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [catalogo, setCatalogo] = useState(null);
  const [loading, setLoading] = useState(true);

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const getCatalogo = async () => {
    setLoading(true);
    try {
      let response = await axios.get(`${process.env.REACT_APP_API_URL}/api/link-catalogo`);
      setCatalogo(response.data[0].catalogoActual);
    } catch (e) {
      setCatalogo(null);
    }
    setLoading(false);
  };

  useEffect(() => {
    setTimeout(() => {
      getCatalogo();
    }, 2000);
  }, []);

  useEffect(() => {
    if (inView) {
      setIframeLoaded(true);
    }
  }, [inView]);

  return (
    <div
      ref={ref}
      style={{ display: "flex", justifyContent: "center", width: "100%", padding: "40px 0" }}
    >
      {loading && (
        <div style={{ width: "100%", textAlign: "center", padding: "40px 0" }}>
          <span>Cargando catálogo...</span>
        </div>
      )}
      {!loading && iframeLoaded && catalogo && (
        <div
          style={{
            position: "relative",
            paddingTop: "max(60%,326px)",
            height: 0,
            width: "90%",
          }}
        >
          <iframe
            allow="clipboard-write"
            sandbox="allow-scripts allow-same-origin"
            allowFullScreen
            style={{
              position: "absolute",
              border: "none",
              width: "100%",
              height: "100%",
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            }}
            src={getIssuuEmbedUrl(catalogo)}
          ></iframe>
        </div>
      )}
      {!loading && !catalogo && (
        <div style={{ width: "100%", textAlign: "center", padding: "40px 0" }}>
          <span>No se pudo cargar el catálogo.</span>
        </div>
      )}
    </div>
  );
};
